module.exports = __webpack_public_path__ + "img/solarpros-logo.ea208e44.png";